import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  DetachedRouteHandle,
  RouteReuseStrategy,
} from '@angular/router';
import { AppRoutes } from '@cnp/common';

@Injectable()
export class CustomReuseRouteService implements RouteReuseStrategy {
  private storedRoutes = new Map<string, DetachedRouteHandle>();

  public shouldDetach(route: ActivatedRouteSnapshot): boolean {
    const path = route.routeConfig?.path ?? '';

    // Detach only the global feed (/feed), not the hub feed (/hubs/:id/feed)
    if (path === 'feed' && !route.parent) {
      return true;
    }

    return path === 'videos';
  }

  public store(
    route: ActivatedRouteSnapshot,
    handle: DetachedRouteHandle | null
  ): void {
    const key = this._getRouteKey(route);
    if (key) {
      this.storedRoutes.set(key, handle!);
    }
  }

  public shouldAttach(route: ActivatedRouteSnapshot): boolean {
    const key = this._getRouteKey(route);
    return !!key && this.storedRoutes.has(key);
  }

  public retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    const key = this._getRouteKey(route);
    return key ? this.storedRoutes.get(key) || null : null;
  }

  public shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot
  ): boolean {
    return this._getRouteKey(future) === this._getRouteKey(curr);
  }

  private _getRouteKey(route: ActivatedRouteSnapshot): string {
    const paths: string[] = [];
    let current: ActivatedRouteSnapshot | null = route;

    while (current) {
      if (current.routeConfig?.path) {
        paths.unshift(current.routeConfig.path);
      }
      current = current.parent;
    }

    return paths.join('/');
  }
}
